import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { fuseAnimations } from '@fuse/animations';
import { Report } from 'app/shared/models/report';
import { messageService } from 'app/shared/services/messages/message.module';
import { IReportService } from 'app/shared/services/reporting/base-report.service';
import { ReportHelper } from 'app/shared/services/reporting/report-helper';
import { ValidateUnique } from 'app/validators/async-unique.validator';

@Component({
  selector: 'report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class ReportDialogComponent implements OnInit {

  btnSaveLabel = 'SAVE';
  title: string;
  readOnly = false;
  form: UntypedFormGroup;
  report: Report;
  reportService: IReportService;

  constructor(
    public dialogRef: MatDialogRef<ReportDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private reportHelper: ReportHelper,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    // Make a copy of the report we are saving
    this.report = new Report(this.data.report);
    this.report.config = this.report.config;

    this.reportService = this.reportHelper.getReportService(this.report);

    if (this.data.saveAsFlag === true) {
      this.title = `Save Report As`;

      // Reset ID, UID & Name if we are performing 'save as'
      this.report.id = null;
      this.report.uid = null;
      this.report.name = null;
      this.btnSaveLabel = 'SAVE AS';
    }
    else {
      this.title = `Save Report`;
      this.btnSaveLabel = 'SAVE';
    }

    this.form = this.formBuilder.group({
      name: [this.report.name, Validators.required],
      description: [this.report.description],
    });

    // add async validator to name field
    this.form.controls['name'].setAsyncValidators(ValidateUnique.createValidator(this.reportService, this.report.id ? this.report.uid : '', 'name'));
  }

  save() {
    const val = this.form.getRawValue();
    this.report.name = val.name;
    this.report.description = val.description;
    this.report.config = this.report.config;
    this.reportService.save(this.report);
    messageService.success(`The report '${val.name}' has been saved`);

    this.reportService.getAllData();

    this.dialogRef.close();
  }
}
